export const removeSpaces = str => {
  return str.replace(/\s+/g, '')
}
